<template>
  <component :is="'style'" type="text/css">
    :root { --color-active: {{ primaryColor }}; --color-active-01: {{ primaryColor01 }}; --color-active-015:
    {{ primaryColor015 }}; --color-active-025: {{ primaryColor025 }}; --color-active-04: {{ primaryColor04 }}; --color-active-06:
    {{ primaryColor06 }}; --color-active-hover: {{ primaryColor08 }}; }
  </component>
</template>
<script setup>
import { computed, inject } from 'vue';

const primaryColor = inject('primaryColor');
const hexColor = computed(() => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(primaryColor.value);
  const color = result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : null;
  return color;
});
const primaryColor01 = computed(() => {
  if (hexColor.value) return 'rgba(' + hexColor.value.r + ',' + hexColor.value.g + ',' + hexColor.value.b + ', 0.1)';
  return 'rgba(242, 174, 67, 0.1);';
});
const primaryColor015 = computed(() => {
  if (hexColor.value) return 'rgba(' + hexColor.value.r + ',' + hexColor.value.g + ',' + hexColor.value.b + ', 0.15)';
  return 'rgba(242, 174, 67, 0.15);';
});
const primaryColor025 = computed(() => {
  if (hexColor.value) return 'rgba(' + hexColor.value.r + ',' + hexColor.value.g + ',' + hexColor.value.b + ', 0.25)';
  return 'rgba(242, 174, 67, 0.25);';
});
const primaryColor04 = computed(() => {
  if (hexColor.value) return 'rgba(' + hexColor.value.r + ',' + hexColor.value.g + ',' + hexColor.value.b + ', 0.4)';
  return 'rgba(242, 174, 67, 0.4);';
});
const primaryColor06 = computed(() => {
  if (hexColor.value) return 'rgba(' + hexColor.value.r + ',' + hexColor.value.g + ',' + hexColor.value.b + ', 0.6)';
  return 'rgba(242, 174, 67, 0.6);';
});
const primaryColor08 = computed(() => {
  if (hexColor.value) return 'rgba(' + hexColor.value.r + ',' + hexColor.value.g + ',' + hexColor.value.b + ', 0.8)';
  return 'rgba(242, 174, 67, 0.8);';
});
</script>
